import { useEffect, useRef } from "react";
import MetaTags from "components/MetaTags";
import { ContainerWithOffset } from "components/Elements/Container";
import AnimatedBox from "components/Elements/AnimatedBox";
import ImageWithTransition from "components/Elements/ImageWithTransition";
import "swiper/css";
import API from "strapi/api";
import Plyr from "plyr";
import parse from "html-react-parser";
import ImageGliph from "components/Elements/ImageGlliph";

export default function Unreleased({ meta_info, content }) {
  useEffect(() => {
    const options = {
      title: "Example Title",
      controls: ["play-large", "progress"],
      autoplay: false,
      muted: true,
      loop: { active: true },
    };
    const players = Array.from(document.querySelectorAll(".video-player")).map(
      (p) => new Plyr(p, options)
    );
  }, []);

  return (
    <>
      <MetaTags
        title={meta_info?.meta_title ? meta_info.meta_title : "UNRELEASED"}
        description={
          meta_info?.meta_description
            ? meta_info.meta_description
            : "ZANAD | An Independent Animation Production Studio"
        }
        image={
          meta_info?.og_image
            ? API.getNextImage(meta_info.og_image, "large")
            : "/public/og-image.jpg"
        }
      />
      <main style={{ backgroundColor: "#FFFFFF" }}>
        <h1 className="offscreen-title">Careers</h1>
        <ContainerWithOffset>
          <p className="mt-8 mb-6 uppercase fluid-type">
            <span className="flex flex-row justify-start">
              <span className="optical-align letter-i">
                <AnimatedBox num={3.5}>The </AnimatedBox>
                <AnimatedBox num={1}>archived</AnimatedBox>
                <AnimatedBox num={2.5}>
                  <ImageGliph src="MARGIN_PENCIL" />
                </AnimatedBox>
                <span className="inline-block 414:inline">
                  <AnimatedBox num={6}>bits</AnimatedBox>
                </span>
              </span>
            </span>
            <span className="flex flex-row justify-end">
              <span className="text-right">
                <AnimatedBox num={2}>that </AnimatedBox>
                <AnimatedBox num={5}>never </AnimatedBox>
                <AnimatedBox num={1.5}>saw </AnimatedBox>
                <AnimatedBox num={4.5}>the</AnimatedBox>
                <AnimatedBox num={2.5}>
                  <ImageGliph src="MARGIN_BLOOD" />
                </AnimatedBox>
                <AnimatedBox num={4.5}>light.</AnimatedBox>
              </span>
            </span>
          </p>

          <div className="unreleased-wrapper">
            {content.Row &&
              content.Row.map((row, key) => {
                return (
                  <section key={key}>
                    {row.__component === "unreleased.image-left" && (
                      <div className="grid grid-cols-12 gap-3 uppercase">
                        <div className="col-span-9">
                          {row.video_url === null ? (
                            <div className="image-container !bg-transparent">
                              <ImageWithTransition
                                src={
                                  process.env.NEXT_PUBLIC_SERVER_STRAPI_API +
                                  row.media.data.attributes.url
                                }
                                alt=""
                                title=""
                                layout="fill"
                                objectFit="cover"
                              />
                            </div>
                          ) : (
                            <div className="unreleased_video">
                              <div
                                className={
                                  row.autoplay === true
                                    ? "video-player autoplay w-100"
                                    : "video-player w-100"
                                }
                              >
                                <iframe
                                  loading="lazy"
                                  id="video"
                                  src={row.video_url}
                                  allowFullScreen
                                  allowtransparency="true"
                                  allow="autoplay"
                                ></iframe>
                              </div>
                            </div>
                          )}
                          {row.media_caption !== "" ? (
                            <div className="grid grid-cols-8 640:grid-cols-9">
                              <div className="col-span-1 640:col-span-3"></div>
                              <div className="col-span-6 my-2 text-center 640:col-span-3 640:my-6 media_caption">
                                {parse(row.media_caption)}
                              </div>
                            </div>
                          ) : (
                            <div className="my-4 640:my-20"></div>
                          )}
                        </div>
                        <div className="flex col-span-3">
                          {row.gif.data && (
                            <div className="self-end yellowguy-wrapper">
                              <div className="grid grid-cols-6">
                                {key === 0 && (
                                  <>
                                    <div className="hidden col-span-1 640:block"></div>
                                    <div className="col-span-6 text-center 640:col-span-4 paragraph_style">
                                      {parse(content.intro_text)}
                                    </div>
                                  </>
                                )}
                                <div className="flex col-span-6">
                                  <div className="self-end image-container !bg-transparent">
                                    <ImageWithTransition
                                      src={
                                        process.env
                                          .NEXT_PUBLIC_SERVER_STRAPI_API +
                                        row.gif.data.attributes.url
                                      }
                                      alt=""
                                      title=""
                                      layout="fill"
                                      objectFit="cover"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    {row.__component === "unreleased.image-right" && (
                      <div className="grid grid-cols-12 gap-3 uppercase">
                        <div className="flex col-span-3">
                          {row.gif.data && (
                            <div className="self-end yellowguy-wrapper">
                              <div className="grid grid-cols-6">
                                <div className="flex col-span-6">
                                  <div className="self-end image-container !bg-transparent">
                                    <ImageWithTransition
                                      src={
                                        process.env
                                          .NEXT_PUBLIC_SERVER_STRAPI_API +
                                        row.gif.data.attributes.url
                                      }
                                      alt=""
                                      title=""
                                      layout="fill"
                                      objectFit="cover"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="col-span-9">
                          {row.video_url === null ? (
                            row.media.data && (
                              <div className="image-container !bg-transparent">
                                <ImageWithTransition
                                  src={
                                    process.env.NEXT_PUBLIC_SERVER_STRAPI_API +
                                    row.media.data.attributes.url
                                  }
                                  alt=""
                                  title=""
                                  layout="fill"
                                  objectFit="cover"
                                />
                              </div>
                            )
                          ) : (
                            <div className="unreleased_video">
                              <div
                                className={
                                  row.autoplay === true
                                    ? "video-player autoplay w-100"
                                    : "video-player w-100"
                                }
                              >
                                <iframe
                                  loading="lazy"
                                  id="video"
                                  src={row.video_url}
                                  allowFullScreen
                                  allowtransparency="true"
                                  allow="autoplay"
                                ></iframe>
                              </div>
                            </div>
                          )}
                          {row.media_caption !== "" ? (
                            <div className="grid grid-cols-8 640:grid-cols-9">
                              <div className="col-span-1 640:col-span-3"></div>
                              <div className="col-span-6 my-2 text-center 640:col-span-3 640:my-6 media_caption">
                                {parse(row.media_caption)}
                              </div>
                            </div>
                          ) : (
                            <div className="my-4 640:my-20"></div>
                          )}
                        </div>
                      </div>
                    )}
                    {row.__component === "unreleased.full-width" && (
                      <div className="grid grid-cols-12 gap-3 uppercase">
                        <div className="col-span-12">
                          {row.video_url === null ? (
                            row.media.data && (
                              <div className="image-container !bg-transparent">
                                <ImageWithTransition
                                  src={
                                    process.env.NEXT_PUBLIC_SERVER_STRAPI_API +
                                    row.media.data.attributes.url
                                  }
                                  alt=""
                                  title=""
                                  layout="fill"
                                  objectFit="cover"
                                />
                              </div>
                            )
                          ) : (
                            <div className="unreleased_video">
                              <div
                                className={
                                  row.autoplay === true
                                    ? "video-player autoplay w-100"
                                    : "video-player w-100"
                                }
                              >
                                <iframe
                                  loading="lazy"
                                  id="video"
                                  src={row.video_url}
                                  allowFullScreen
                                  allowtransparency="true"
                                  allow="autoplay"
                                ></iframe>
                              </div>
                            </div>
                          )}
                          {row.media_caption !== "" ? (
                            <div className="grid grid-cols-12">
                              <div className="col-span-3"></div>
                              <div className="col-span-6 my-2 text-center 640:my-6 media_caption">
                                {parse(row.media_caption)}
                              </div>
                            </div>
                          ) : (
                            <div className="my-4 640:my-20"></div>
                          )}
                        </div>
                      </div>
                    )}
                  </section>
                );
              })}
          </div>
        </ContainerWithOffset>
      </main>
    </>
  );
}

// Unreleased.getInitialProps = async ctx => {
//     const content = await API.getSingleType('unreleased')

//     return {
//         content: content,
//     }
// }

export async function getStaticProps(ctx) {
  const content = await API.getSingleType("unreleased");

  return {
    props: {
      content: content,
    },
    revalidate: 10,
  };
}
